<template>
	<div style="width: 100%;height:170px;" v-if="loaclData">

		<!-- 底栏文字 -->
		<div class="sd_bottom">
			<div class="bottom_inner">
				<div @mouseleave="leaveClose">
					<div class="bottm_inner_first">
						<p @mouseenter="showLink('1')">部委网站</p>
						<p>|</p>
						<p @mouseenter="showLink('2')">行业协会网站</p>
					</div>
					<div class="after_add_bottm">
						<div class="floatLink" v-show="showOne" @mouseleave="showOne = false">
							<span v-for="(item,index) in linkListOne" @click="navToPage(item)" :key="index">
								{{item.link_name}}
							</span>
						</div>
						<div class="floatLink2" v-show="showTwo" @mouseleave="showTwo = false">
							<span v-for="(item,index) in linkListTwo" @click="navToPage(item)" :key="index">
								{{item.link_name}}
							</span>
						</div>
					</div>
				</div>


				<div class="bottom_inner_top">
					<div class="inner_top_list">
						<img :src="imgsrc5" alt="">
						<p>联系地址：{{indexInfo.address}}</p>
					</div>

					<div class="inner_top_list">
						<!-- 渝公安备 -->
						<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50010302003074" 
						target="_blank">
							<p style="margin-left: 100px;">{{indexInfo.record_number}}</p>
						</a>
					</div>

					<div class="inner_top_list">
						<!-- 版权所有 -->
						<p class="special_pright">版权所有：{{indexInfo.copyright_owner}}</p>
					</div>

					<!-- 第二排3个 -->

					<div class="inner_top_list">
						<img :src="imgsrc1" alt="">
						<p>联系电话：{{indexInfo.cellphone}}</p>
					</div>
					<div class="inner_top_list">
						<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
							<p style="margin-left: 100px;">{{indexInfo.icp}}</p>
						</a>
					</div>
					<div class="inner_top_list">
						<p class="special_pright">网站维护：重庆市建筑业协会综合办公室</p>
					</div>

					<!-- 第三排 -->
					<div class="inner_top_list">
						<img :src="imgsrc3" alt="">
						<p>邮编：{{indexInfo.post_code}}</p>
					</div>
					<div class="inner_top_list">
						<a href="https://www.newgrand.cn/" target="_blank" style="text-decoration: none;">
							<p class="newbottom_p special_pright">网站建设：{{indexInfo.technical_support}}</p>
						</a>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
	import {
		apiRequest
	} from '../assets/js/axios/request.js'

	export default {
		data() {
			return {
				indexInfo: {},
				friendShip: [],
				loaclData: true,
				imgsrc1: require('../assets/img/main/phone.png'),
				imgsrc2: require('../assets/img/main/dayin.png'),
				imgsrc3: require('../assets/img/main/postcode.png'),
				imgsrc4: require('../assets/img/main/post.png'),
				imgsrc5: require('../assets/img/main/address.png'),
				linkListOne: [],
				showOne: false,
				linkListTwo: [],
				showTwo: false
			}
		},
		props: {
			isfirst: {
				type: Boolean,
				default: false
			},
			indexinfo: {
				type: Object,
				default: () => {}
			}
		},
		watch: {
			indexinfo(newValue) {
				// console.log('首页信息', newValue)
				this.indexInfo = newValue
			}
		},
		created() {
			// 部委信息 
			this.getFriendlink('DFACF5CC-93B4-FAEC-7F1C-8059A5E58BF1', '1')
			// 行业协会 
			this.getFriendlink('FA4377A-D28B-5AD1-85FD-BF7D2B76F978', '2')
		},
		methods: {
			navToPage(item){
				window.open(item.link_path)
			},
			// 离开友情链接
			leaveClose() {
				this.showOne = false
				this.showTwo = false
			},
			// 展示友情链接
			showLink(type) {
				if (type === '1') {
					this.showOne = true
					this.showTwo = false
				} else {
					this.showTwo = true
					this.showOne = false
				}
			},

			// 友情链接
			async getFriendlink(column_code, type) {
				await apiRequest({
					method: 'post',
					url: '/adminapi/web/get-web-link',
					data: {
						column_code
					},
					success: (res) => {
						if (type === '1') {
							this.linkListOne = res.data
						} else {
							this.linkListTwo = res.data
						}
					}
				})
			},
		}
	}
</script>
<style>
	.floatLink2 {
		padding: 5px 0;
		position: absolute;
		z-index: 999;
		height: auto;
		bottom: 20px;
		left: 50%;
		overflow-y: scroll;
		min-width: 150px;
		display: flex;
		background-color: #FFFFFF;
		border: 1px solid #eee;
		flex-flow: column;
	}

	.floatLink {
		padding: 5px 0;
		position: absolute;
		z-index: 999;
		height: auto;
		bottom: 20px;
		left: 18%;
		overflow-y: scroll;
		min-width: 150px;
		display: flex;
		background-color: #FFFFFF;
		border: 1px solid #eee;
		flex-flow: column;
	}

	.floatLink span,
	.floatLink2 span {
		color: #000;
		padding: 5px 10px;
	}

	.floatLink span:hover,
	.floatLink2 span:hover {
		cursor: pointer;
		background-color: #015AAA;
		color: #fff;
	}

	.new_sa_link {
		width: 100%;
		min-height: 120px;
		height: auto;
		background-color: #015AAA;
	}

	.link_inner {
		box-sizing: border-box;
		width: 1200px;
		min-height: 140px;
		height: auto;
		margin-left: auto;
		margin-right: auto;
		display: flex;
	}

	.link_innerLeft {
		width: 82%;
	}

	.leftPtitle {
		height: 60px;
		line-height: 60px;
		font-size: 22px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #FFFFFF;
		text-decoration: underline;
	}

	.link_bot {
		min-height: 80px;
		height: auto;
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		align-content: space-around;
		align-items: center;

		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
	}

	.link_bot_List {
		min-width: 164px;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}

	.link_innerRight {
		width: 18%;
		display: flex;
		flex-flow: column;
		align-items: flex-end;
		justify-content: center;
	}

	.sd_bottom {
		width: 100%;
		height: 170px;
		background: #125DB2;
		padding-top: 29px;
	}

	.bottom_inner {
		width: 1200px;
		margin-left: auto;
		margin-right: auto;
		box-sizing: border-box;
	}

	.after_add_bottm {
		width: 50%;
		margin-left: auto;
		margin-right: auto;
		position: relative;
	}

	.bottm_inner_first {
		width: 294px;
		margin-left: auto;
		margin-right: auto;
		/* display: flex; */
		/* justify-content: center; */
		color: #FFFFFF;
		position: relative;
	}

	.bottm_inner_first p {
		display: inline-block;
		width: 98px;
		text-align: center;
		cursor: pointer;
	}

	.bottom_inner_top {
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-top: 31px;
	}

	.inner_top_list {
		display: flex;
		align-items: center;
		width: 33%;
		margin-bottom: 15px;
	}
	.inner_top_list a{
		text-decoration: none;
	}
	
	.inner_top_list p,.inner_top_list a>p {
		margin-left: 5px;
		min-height: 17px;
		font-size: 16px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		line-height: 17px;
	}

	.newlink_innerRight {
		display: none;
	}

	.newlink_innerRight p {
		margin-top: 6px;
		height: 17px;
		font-size: 12px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 17px;
	}

	.footerSupport {
		display: none;
	}

	.newfooterSupport {
		display: flex;
		justify-content: space-around;
		align-items: center;
		cursor: pointer;
		margin-top: 24px;
	}

	.bottom_p {
		height: 35px;
		line-height: 35px;
		font-size: 12px;
		color: #FFFFFF;
	}

	.newbottom_p {
		height: 25px;
		font-family: PingFangSC-Regular;
		font-size: 16px;
		color: #FFFFFF;
		letter-spacing: 0;
		text-align: right;
		font-weight: 400;
	}

	.special_pright {
		margin-left: 108px !important;
	}
</style>
